import { z } from 'zod';

import { maxDiscountSchema } from '../schema';

export const updateSchema = maxDiscountSchema;

export type UpdateForm = z.infer<typeof updateSchema>;
